import React from "react";
import "./tables.css";
import { Box, Typography } from "@mui/material";
import LinearProgress from "@mui/material/LinearProgress";

const ShowLoadingBar = ({ title, loading }) => {
  const style = {
    bgcolor: "background.paper",
    border: "1px solid",
    borderColor: "divider",
    borderRadius: 3,
    boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
    p: 4,
    maxWidth: 480,
    mx: "auto",
    mt: 6,
    textAlign: "center",
  };

  return (
    <div className="loadin-main-container">
      <Box sx={style}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
          Loading…
        </Typography>
        <LinearProgress sx={{ width: "100%", borderRadius: 1 }} />
      </Box>
    </div>
  );
};

export default ShowLoadingBar;
